import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/common/Button';
import { theme } from '../../config/theme';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: theme.spacing.xl }}>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: '72px', fontWeight: theme.typography.fontWeight.bold, color: theme.colors.primary.main }}>404</h1>
        <h2 style={{ fontSize: theme.typography.fontSize['2xl'], fontWeight: theme.typography.fontWeight.semibold, marginBottom: theme.spacing.md }}>Page Not Found</h2>
        <p style={{ color: theme.colors.text.secondary, marginBottom: theme.spacing.xl }}>The page you're looking for doesn't exist.</p>
        <Button onClick={() => navigate('/')}>Go Home</Button>
      </div>
    </div>
  );
};

export default NotFound;